module.exports = __webpack_public_path__ + "static/media/MaisonNeue-Book.dcf65514.otf";